/**
 * @generated SignedSource<<ecd3626feeb3b4b3b69b7eef98d48a45>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DescriptionContentFiles_files$data = ReadonlyArray<{
  readonly id: string;
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"FileCollectionItem_File">;
  readonly " $fragmentType": "DescriptionContentFiles_files";
}>;
export type DescriptionContentFiles_files$key = ReadonlyArray<{
  readonly " $data"?: DescriptionContentFiles_files$data;
  readonly " $fragmentSpreads": FragmentRefs<"DescriptionContentFiles_files">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "DescriptionContentFiles_files",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FileCollectionItem_File"
    }
  ],
  "type": "File",
  "abstractKey": null
};

(node as any).hash = "b7bf07d8bd2d2138267761d7e4935efe";

export default node;
